"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Iconcommunities = function Iconcommunities(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "IconcommunitiesTitle IconcommunitiesDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "IconcommunitiesTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "IconcommunitiesDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "35.196",
    cy: "2.959",
    r: "2.042"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "4.956",
    cy: "53.044",
    r: "2.042"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "63.787",
    cy: "53.044",
    r: "2.042"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.3333333333333333 0.3333333333333333)",
    d: "M2.076 43.593a1.31 1.31 0 0 1-1.309-1.074C-2.426 25.537 7.288 8.774 23.611 3.103a1.31 1.31 0 0 1 .864 2.474A32.36 32.36 0 0 0 2.809 36.092c.002 1.993.186 3.983.55 5.943a1.31 1.31 0 0 1-1.047 1.532l-.236.026zm66.136 0h-.236a1.31 1.31 0 0 1-1.047-1.532A32.348 32.348 0 0 0 45.813 5.577a1.31 1.31 0 1 1 .864-2.474 34.992 34.992 0 0 1 23.42 32.989 35.804 35.804 0 0 1-.59 6.427 1.31 1.31 0 0 1-1.295 1.074zM35.144 71.044a34.9 34.9 0 0 1-22.87-8.535 1.31 1.31 0 0 1 1.715-1.977c12.144 10.527 30.179 10.527 42.323 0a1.31 1.31 0 0 1 1.715 1.977 34.927 34.927 0 0 1-22.883 8.535zm12.685-16.782H22.564a1.31 1.31 0 0 1-1.31-1.31V43.79a9.255 9.255 0 0 1 9.243-9.242h9.412a9.255 9.255 0 0 1 9.242 9.242v9.164a1.31 1.31 0 0 1-1.322 1.309zm-23.956-2.618H46.52v-7.855a6.637 6.637 0 0 0-6.624-6.624h-9.412a6.637 6.637 0 0 0-6.611 6.598v7.88zm11.035-22.36a7.501 7.501 0 1 1 7.488-7.5 7.514 7.514 0 0 1-7.488 7.5zm0-12.37a4.883 4.883 0 1 0-.026 9.765 4.883 4.883 0 0 0 .026-9.766z"
  })));
};

Iconcommunities.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Iconcommunities.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Iconcommunities;
exports["default"] = _default;